import script from "./MarksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MarksPage.vue?vue&type=script&setup=true&lang=js"

import "./MarksPage.vue?vue&type=style&index=0&id=5d2329f9&lang=css"

const __exports__ = script;

export default __exports__